import { MenuItem } from '@headlessui/react'
import { MenuOption, type MenuOptionProps } from '../components/menu-option.tsx'

type PopoutItemProps = Readonly<MenuOptionProps>

export const PopoutItem = (props: PopoutItemProps) => {
  return (
    <MenuItem>
      <MenuOption {...props} />
    </MenuItem>
  )
}
